import { createFileRoute } from '@tanstack/react-router';

import { ProtectedRoute } from '@/components';
import ClientVmsConfigDashboard from '@/pages/ClientVmsConfigDashboard';

export const Route = createFileRoute('/config/client-vms-config')({
  component: () => (
    <ProtectedRoute>
      <ClientVmsConfigDashboard />
    </ProtectedRoute>
  ),
});
